.added {
  font: var(--font-label-2);
}
